import {
  FETCH_TALENT_EVALUATIONS,
  FETCH_TALENT_EVALUATIONS_SUCCESS,
  FETCH_TALENT_EVALUATIONS_ERROR,
  SAVE_TALENT_EVALUATION,
  SAVE_TALENT_EVALUATION_SUCCESS,
  SAVE_TALENT_EVALUATION_ERROR,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: null,
  loading: true,
  saving: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  // console.log('action received: ', action);
  switch(action.type){
    case FETCH_TALENT_EVALUATIONS:
      return {
        ...state,
        data: null,
        loading: true,
        error: null,
      }
    break;
    case FETCH_TALENT_EVALUATIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    break;
    case FETCH_TALENT_EVALUATIONS_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      }
    break;
    case SAVE_TALENT_EVALUATION:
      return {
        ...state,
        saving: true,
        error: null,
      }
    break;
    case SAVE_TALENT_EVALUATION_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data,
          action.payload
        ],
        saving: false,
        error: null,
      }
    break;
    case SAVE_TALENT_EVALUATION_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload,
      }
    break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/talentEvaluationsReducer.js